<main>
  <app-spinner></app-spinner>
  <router-outlet></router-outlet>
  <div *ngIf="showCountdown" class="session-timer">
    ⏳ Session ends in {{ formattedTimeLeft() }}
  </div>
</main>
